import { useMutation } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";

export const useCreateStripeAccountLink = () => {
    const client = useApiClient();
    return useMutation({
        mutationKey: ['createStripeAccountLink'],
        mutationFn: (dto: { organizationId: string; refreshUrl: string; returnUrl: string }) => client.fetchApi<{ url: string }, { organizationId: string; refreshUrl: string; returnUrl: string }>({ endpoint: `organizations/account-link`, method: 'POST', body: dto }),
    });
};